export default "__VITE_ASSET__CAm5oCAZ__"